// extracted by mini-css-extract-plugin
export default {"info":"style_info__9qlyG"};